export const getError = (error) => {
  if (error.response && error.response.data) {
    return { ...error.response.data, status: error.response.status };
  }
  if (error.message) {
    return { message: error.message, status: null };
  }
  return { message: 'Unknown Error.', status: null };
};
